import { style } from '@angular/animations';
import { Injectable } from '@angular/core';
import { CommonServiceModule } from './common-service.module';

@Injectable({
  providedIn: CommonServiceModule
})
export class appConstants {

  // { path: 'secAFC', component: SecAFComponent },
  // { path: 'secAOB', component: SecAOBComponent },
  // { path: 'secARPL', component: SecARPLComponent },
  // { path: 'secLegal', component: SecLegalComponent },
  // { path: 'secPolicy', component: SecPolicyComponent },
  // { path: 'secVote', component: SecVoteofThnksComponent },
  // { path: 'secConfirm', component: SecConfirmMinComponent },
  // { path: 'secDashboard', component: SecDashboardComponent },
  // { path: 'secNoteRecord', component: SecNoteRecordComponent },
  // { path: 'secConduct', component: SecConductMeetingComponent },
  // { path: 'secActionTaken', component: SecActionTakenComponent },
  // { path: 'secSupplementary', component: SecSupplementaryComponent }

  secSidenav = [
    { linkName: 'Note & Record Apologies', router: 'excu/CZsQVJe0x6/secNoteRecord' },
    { linkName: 'Confirm Minutes Meeting', router: 'excu/CZsQVJe0x6/secConfirm' },
    { linkName: 'Action Taken on Meeting', router: 'excu/CZsQVJe0x6/secActionTaken' },
    { linkName: 'Policy Matters', router: 'excu/CZsQVJe0x6/secPolicy' },
    { linkName: 'Academic Matters', router: 'excu/CZsQVJe0x6/secAcademic' },
    { linkName: 'ARPM Matters', router: 'excu/CZsQVJe0x6/secARPL' },
    { linkName: 'Administration Matters', router: 'excu/CZsQVJe0x6/secAdminstration' },
    { linkName: 'Account and Finance Matters', router: 'excu/CZsQVJe0x6/secAFC' },
    { linkName: 'Legal/RTI/Public Grievance Matters', router: 'excu/CZsQVJe0x6/secLegal' },
    { linkName: 'Inspection/Membership Matters', router: 'excu/CZsQVJe0x6/secInspection' },
    { linkName: 'Para Dentist and Miscellaneous Matters', router: 'excu/ec/secPDMS' },
    { linkName: 'Admission Matters', router: 'excu/ec/secAdmission' },
    { linkName: 'Supplementary Items', router: 'excu/CZsQVJe0x6/secSupplementary' },
    { linkName: 'Any Other Business', router: 'excu/CZsQVJe0x6/secAOB' },
    { linkName: 'Vote of Thanks', router: 'excu/CZsQVJe0x6/secVote' }
  ]

  ecSidenav = [
    { linkName: 'Agenda', router: 'excu/ec/ecagenda' },
    { linkName: 'Create New Meeting', router: 'excu/ec/maintaindatevenue' },
    { linkName: 'Completed Meeting', router: 'excu/ec/eccompletedmeeting' },
    { linkName: 'PDF/Print Agenda', router: 'excu/ec/exportPdfAgendaList' },
    { linkName: 'Print/Download Minutes', router: 'excu/ec/downloadmeeting' },

    // { linkName: 'Completed List', router: 'excu/ec/completedListEC' },
  ];

  ecSubsidenav = [
    { linkName: 'Note & Record Apologies', router: 'excu/ec/noterecordapologies' },
    { linkName: 'Confirm Minutes Meeting', router: 'excu/ec/confirminutes' },
    { linkName: 'Action Taken on Meeting', router: 'excu/ec/actiontaken' },
    { linkName: 'Policy Matters', router: 'excu/ec/policymatter' },
    { linkName: 'Academic Matters', router: 'excu/ec/academicmatter' },
    { linkName: 'ARPM Matters', router: 'excu/ec/arplmatter' },
    { linkName: 'Administration Matters', router: 'excu/ec/administrationmatter' },
    { linkName: 'Account and Finance Matters', router: 'excu/ec/accfinancematter' },
    { linkName: 'Legal/RTI/Public Grievance Matters', router: 'excu/ec/legalpublicmatter' },
    { linkName: 'Membership Matters', router: 'excu/ec/membershipmatter' },
    { linkName: 'Para Dentist and Miscellaneous Matters', router: 'excu/ec/pdmmatter' },
    { linkName: 'Admission Matters', router: 'excu/ec/admissionmatter' },
    { linkName: 'Inspection Matters', router: 'excu/ec/inspectionmatter' },
    { linkName: 'Supplementary Items', router: 'excu/ec/supplementary' },
    { linkName: 'Any Other Business', router: 'excu/ec/anyotherbusiness' },
    { linkName: 'Date & Venue Next Meeting', router: 'excu/ec/DateAndVenueNextMeetingComponent' },
    { linkName: 'Vote of Thanks', router: 'excu/ec/voteofthanks' }
  ];

  InsCell = [
  
    // { linkName: 'Inspection Scheduling', router: 'inspection/insCell/createIns' },
    { linkName: 'Manage Inspection', router: 'inspection/insCell/inspList' },
    { linkName: 'Track Inspection', router: 'inspection/insCell/trackInspList' },
    { linkName: 'Team Formed', router: 'inspection/insCell/completedinspec' },
    { linkName: 'Cancelled Inspection', router: 'inspection/insCell/cancelledinspec' },
    { linkName: 'Conclude Inspection', router: 'inspection/insCell/concludeInspList' },        
    
    { linkName: 'Appointed Inspectors', router: 'inspection/insCell/appointedInspectorsList' },
    { linkName: 'Available Inspector Details', router: 'inspection/insCell/avalInspectors' },

    { linkName: 'Maintain Inspector', router: 'inspection/insCell/inspectorMaster' },
    { linkName: 'Inspector Utilization Report', router: 'inspection/insCell/inspectorutilizationreport' },
    { linkName: 'Exhausted inspector pool', router: 'inspection/insCell/exaustedInspectorPool' },



    // { linkName: 'Inspection Report', router: 'inspection/insCell/insreport' },
    // { linkName: 'Sample Proforma', router: 'inspection/insCell/sample-proforma' },
    // { linkName: 'Inspector Fee Report', router: 'inspection/insCell/inspectorfee' },
    // { linkName: 'Travel Agent Claim', router: 'inspection/insCell/travelagentclaim' },
    // { linkName: 'College Payment Status', router: 'inspection/insCell/collegepayment' }
  ];
InspCellForPresident = [
  
    // { linkName: 'Inspection Scheduling', router: 'inspection/insCell/createIns' },
    { linkName: 'Manage Inspection', router: 'inspection/insCell/inspList' },
    { linkName: 'Track Inspection', router: 'inspection/insCell/trackInspList' },
    { linkName: 'Team Formed', router: 'inspection/insCell/completedinspec' },
    { linkName: 'Cancelled Inspection', router: 'inspection/insCell/cancelledinspec' },
    { linkName: 'Conclude Inspection', router: 'inspection/insCell/concludeInspList' },   
    { linkName: 'Appointed Inspectors', router: 'inspection/insCell/appointedInspectorsList' },
    { linkName: 'Available Inspector Details', router: 'inspection/insCell/avalInspectors' },
    { linkName: 'Maintain Inspector', router: 'inspection/insCell/inspectorMaster' },
    { linkName: 'Inspector Utilization Report', router: 'inspection/insCell/inspectorutilizationreport' },
    { linkName: 'Exhausted inspector pool', router: 'inspection/insCell/exaustedInspectorPool' },

    // { linkName: 'Inspection Report', router: 'inspection/insCell/insreport' },
    // { linkName: 'Sample Proforma', router: 'inspection/insCell/sample-proforma' },
    // { linkName: 'Inspector Fee Report', router: 'inspection/insCell/inspectorfee' },
    // { linkName: 'Travel Agent Claim', router: 'inspection/insCell/travelagentclaim' },
    // { linkName: 'College Payment Status', router: 'inspection/insCell/collegepayment' }
  ];
  
  InspCellForChairperson = [
  
    //{ linkName: 'Inspection Scheduling', router: 'inspection/insCell/createIns' },
    { linkName: 'Manage Inspection', router: 'inspection/insCell/newinspList' },
    { linkName: 'Track Inspection', router: 'inspection/insCell/newtrackInspList' },
    { linkName: 'Team Formed', router: 'inspection/insCell/completedinspec' },
    { linkName: 'Cancelled Inspection', router: 'inspection/insCell/cancelledinspec' },
    { linkName: 'Conclude Inspection', router: 'inspection/insCell/newconcludeInspList' },   
    { linkName: 'Appointed Inspectors', router: 'inspection/insCell/appointedInspectorsList' },
    { linkName: 'Available Inspector Details', router: 'inspection/insCell/avalInspectors' },
    { linkName: 'Maintain Inspector', router: 'inspection/insCell/inspectorMaster' },
    { linkName: 'Inspector Utilization Report', router: 'inspection/insCell/inspectorutilizationreport' },
    { linkName: 'Exhausted inspector pool', router: 'inspection/insCell/exaustedInspectorPool' },

    // { linkName: 'Inspection Report', router: 'inspection/insCell/insreport' },
    // { linkName: 'Sample Proforma', router: 'inspection/insCell/sample-proforma' },
    // { linkName: 'Inspector Fee Report', router: 'inspection/insCell/inspectorfee' },
    // { linkName: 'Travel Agent Claim', router: 'inspection/insCell/travelagentclaim' },
    // { linkName: 'College Payment Status', router: 'inspection/insCell/collegepayment' }
  ];

   InspCellForInspectionExecutive = [
  
    { linkName: 'Inspection Scheduling', router: 'inspection/insCell/createIns' },
    { linkName: 'Manage Inspection', router: 'inspection/insCell/newinspList' },
    { linkName: 'Track Inspection', router: 'inspection/insCell/newtrackInspList' },
    
    { linkName: 'Conclude Inspection', router: 'inspection/insCell/newconcludeInspList' },   
    
  ];
  InsCellForAcademic = [
    { linkName: 'Manage Inspection', router: 'inspection/insCell/inspList' },
    { linkName: 'Track Inspection', router: 'inspection/insCell/trackInspList' },
    { linkName: 'Conclude Inspection', router: 'inspection/insCell/concludeInspList' },        
    { linkName: 'Inspection Scheduling', router: 'inspection/insCell/createIns' },    
  ];

  InsCellForPDMS = [
    { linkName: 'Manage Inspection', router: 'inspection/insCell/inspList' },
    { linkName: 'Track Inspection', router: 'inspection/insCell/trackInspList' },
    { linkName: 'Conclude Inspection', router: 'inspection/insCell/concludeInspList' },        
    { linkName: 'Inspection Scheduling', router: 'inspection/insCell/createIns' },    
  ];



  InsCellForSecretaryIncharge = [
    { linkName: 'Manage Inspection', router: 'inspection/insCell/inspList' },
    { linkName: 'Track Inspection', router: 'inspection/insCell/trackInspList' },
    { linkName: 'Conclude Inspection', router: 'inspection/insCell/concludeInspList' },        

  ];

   InsCellForSecretary = [
    { linkName: 'Manage Inspection', router: 'inspection/insCell/inspList' },
    { linkName: 'Track Inspection', router: 'inspection/insCell/trackInspList' },
    { linkName: 'Conclude Inspection', router: 'inspection/insCell/concludeInspList' },        

  ];
  InspSec = [
    { linkName: 'Manage Inspection', router: 'inspection/insCell/inspList' },
    { linkName: 'Track Inspection', router: 'inspection/insCell/trackInspList' },
    { linkName: 'Team Formed', router: 'inspection/insCell/completedinspec' },
    { linkName: 'Cancelled Inspection', router: 'inspection/insCell/cancelledinspec' },
    { linkName: 'Conclude Inspection', router: 'inspection/insCell/concludeInspList' },  
    { linkName: 'Maintain Inspector', router: 'inspection/insCell/inspectorMaster' },
    { linkName: 'Available Inspector Details', router: 'inspection/insCell/avalInspectors' },
    // { linkName: 'Appointed Inspectors', router: 'inspection/insCell/appointedInspectorsList' },
    { linkName: 'Inspector Utilization Report', router: 'inspection/insCell/inspectorutilizationreport' },
    { linkName: 'Exhausted inspector pool', router: 'inspection/insCell/exaustedInspectorPool' },

  ];
 
  InsCellForSeverExecutive= [
    { linkName: 'Manage Inspection', router: 'inspection/insCell/inspList' },   
    { linkName: 'Track Inspection', router: 'inspection/insCell/trackInspList' }

];
  Insproforma = [
    { linkName: 'College Information', router: 'inspection/inspectionproforma/collegeInformation'},
    { linkName: 'General Information', router: 'inspection/inspectionproforma/generalInformation'},
    { linkName: 'Library Details', router: 'inspection/inspectionproforma/libraryDetails'},
    { linkName: 'Hostel Facility for PG', router: 'inspection/inspectionproforma/hostelFacility'},
    { linkName: 'Teaching Staff', router: 'inspection/inspectionproforma/teachingStaff'},
    { linkName: 'Equipments', router: 'inspection/inspectionproforma/equipments'},
    { linkName: 'Infrastructure Details', router: 'inspection/inspectionproforma/infrastructure'},
    { linkName: 'Staff Assessment for Publications', router: 'inspection/inspectionproforma/staffAssessmentPublications'},
    { linkName: 'Last Annual Admission details for Specialty', router: 'inspection/inspectionproforma/lastAnnualAdmissionSpecialty'},
    { linkName: 'Clinical Work Load', router: 'inspection/inspectionproforma/clinicalWorkLoad'},
    { linkName: 'Student Academic Presentation', router: 'inspection/inspectionproforma/studentAcademicDashboard'},
    { linkName: 'Teaching/Learning Activities', router: 'inspection/inspectionproforma/teachingLearningActivitiesDashboard'},
    { linkName: 'Submit Inspection', router: 'inspection/inspectionproforma/submitInspection'},

  ];

  InsCellForAcccount = [
    { linkName: 'Travel Agent Claim', router: 'inspection/insCell/travelagentclaim' },
  ];

  
  travelAgent = [
    { linkName: 'Dashboard', router: 'inspection/tavelagent/dashboard' },
    { linkName: 'Bookings', router: 'inspection/tavelagent/shedule/1' },
    { linkName: 'Claims', router: 'inspection/tavelagent/allClaims' }
  ];

  // form Error messages
  errorMsgs = {
    digits: 'Allow only Digits',
    email: 'Proper Email Required',
    lengthValue: 'length is ',
    wrongPwd: 'Old password is Wrong',
    required: 'Field is Required'
  };
  // error Handlings Messages
  errorsHandlings = {
    404: 'Page Not Found', // actually error page
    // 401: 'Unauthorized Please Login Again',
    401: 'Session has expired!!!',
    417: ' Expectation Failed',
    500: 'Oops!! Something went wrong please try after some time'
  };
  // Tiny Editor Config
  config: any = {
    height: 250,
    theme: 'modern',
    browser_spellcheck: true,
    plugins: 'directionality contextmenu visualblocks visualchars fullscreen imagetools media template table codesample charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists textcolor wordcount contextmenu textpattern', 
    toolbar: 'undo redo |  formatselect | bold italic underline fontselect fontsizeselect | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat',
    //table_toolbar:'',
    // menubar:'table',
    table_toolbar: 'tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
     //toolbar_mode:'wrap',
    //table_tab_navigation: false,
     table_advtab: false,
     table_row_advtab: false,
     table_cell_advtab: false,
    //table_appearance_options: false,
    //entirely unexpected from the user’s perspective
    menu: {
      //  insert: {title: 'Insert', items: 'link media | template hr'},
       file: {title: 'File', items: 'newdocument'},
       format: {title: 'Format', items: 'bold italic underline | removeformat'},
       insert: { title: 'Insert', items: 'inserttable | hr' },
       edit: {title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall'},
       //view: { title: 'View', items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen' },
       //file: { title: 'File', items: 'newdocument restoredraft | preview | print ' },
     //edit: { title: 'Edit', items: 'undo redo | cut copy paste | selectall | searchreplace' },
     
   
     
    // table: { title: 'Table', items: 'inserttable | cell row column | tableprops deletetable' }
     },
    contextmenu:'table deletetable', 
    fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
    font_formats:
    "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Arial Narrow=arial narrow, Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Verdana=verdana,geneva; Wingdings=wingdings,zapf dingbats",
    //menubar:false,
    // setup : function(ed) {
    //   ed.on('init', function(ed) {
    //    ed.target.editorCommands.execCommand("fontName", false, "arial narrow");
    //    ed.target.editorCommands.execCommand("fontSize", false, "12pt");
    //   });
    //  },
     content_style: ".mce-content-body {font-size:12pt;font-family:arial narrow;}",
    templates: [
    { title: 'Test template 1', content: 'Test 1' },
    { title: 'Test template 2', content: 'Test 2' }
    ],
    
    content_css: [
      '//fonts.googleapis.com/css?family=Lato:300,300i,400,400i',
      '//www.tinymce.com/css/codepen.min.css'
    ]
    };
}

export const constServicesProvider = [appConstants];